export default "__VITE_ASSET__DUxo1ufS__"